// Far out the globe fills about three quarters of the shorter screen side (Max, 24.10.): a tiny globe is hard to turn on a
// phone. MapLibre keeps the globe at least 512*2^minZoom/pi px wide (its zoom limit is adjusted for the latitude of the
// centre; measured: 163 px at minZoom 0, 326 px at 1), so the limit follows from the size of the map; re-applied on resize.
export const GLOBE_FILL=.75;
export const globeMinZoom=(width,height,fill=GLOBE_FILL)=>Math.max(0,+Math.log2(fill*Math.min(width,height)*Math.PI/512).toFixed(2));
export function limitGlobeZoom(map){
  if(map._w2cGlobeZoom||!map.getContainer)return;map._w2cGlobeZoom=true;
  const apply=()=>{const c=map.getContainer();if(c.clientWidth&&c.clientHeight)map.setMinZoom(globeMinZoom(c.clientWidth,c.clientHeight));};
  apply();map.on('resize',apply);
}
